import tenantIdentifierInfoService from 'Services/api/tenantIdentifierInfo.service'
import dayjs from 'dayjs'
import ErrorPage from 'pages/ErrorPage/ErrorPage'
import LicenseExpiredPage from 'pages/LicenseErrorPage/LicenseExpiredPage'
import NoLicensePage from 'pages/LicenseErrorPage/NoLicensePage'
import SplashPage from 'pages/SplashPage'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { SET_TENENT_INFO } from 'store/reducers/tenantIdentifierInfo.reducer'

enum LicenseCheckState {
    Start,
    Checking,
    LicenseValid,
    LicenseExpired,
    NoLicense,
    Error,
}

function AppLicenseProvider({ children }: { children: React.ReactNode }) {
    const dispatch = useDispatch()
    const [checkState, setCheckState] = useState<LicenseCheckState>(
        LicenseCheckState.Start,
    )
    const [fetchingErrorMessage, setFetchingErrorMessage] = useState<
        string | null
    >(null)

    const checkLicense = useCallback(async () => {
        setCheckState(LicenseCheckState.Checking)
        try {
            const tenantInfo = (
                await tenantIdentifierInfoService.getTenantIdentifierInfo()
            ).data
            dispatch({ type: SET_TENENT_INFO, payload: tenantInfo })

            if (!tenantInfo.companyLicense)
                setCheckState(LicenseCheckState.NoLicense)
            else {
                if (
                    tenantInfo.companyLicense.validToDate &&
                    dayjs(tenantInfo.companyLicense.validToDate)
                        .toDate()
                        .valueOf() <= new Date().valueOf()
                )
                    setCheckState(LicenseCheckState.LicenseExpired)
                else setCheckState(LicenseCheckState.LicenseValid)
            }
        } catch (err: any) {
            setFetchingErrorMessage(err?.message)
            setCheckState(LicenseCheckState.Error)
        }
    }, [dispatch])

    useEffect(() => {
        checkLicense()
    }, [checkLicense])

    switch (checkState) {
        case LicenseCheckState.Checking:
            return <SplashPage />
        case LicenseCheckState.Error:
            return (
                <ErrorPage
                    message={
                        fetchingErrorMessage ?? 'Error while checking license'
                    }
                />
            )
        case LicenseCheckState.NoLicense:
            return <NoLicensePage />
        case LicenseCheckState.LicenseExpired:
            return <LicenseExpiredPage />
        case LicenseCheckState.LicenseValid:
            return <>{children}</>
        default:
            return <div>Unhandle route</div>
    }
}

export default AppLicenseProvider
